/* eslint-disable perfectionist/sort-objects */

const dashboardSectionMapping: { [key: string]: PageMapping } = {
	"/intelligence/dashboard/overview": {
		nav: true,
		title: "Overview",
		titleKey: "nav.intelligence.dashboard.overview.title",
		label: "Overview",
		labelKey: "nav.intelligence.dashboard.overview.label",
		icon: "home",
		buttons: [],
		actions: []
	},
	"/intelligence/dashboard/my-business": {
		nav: true,
		title: "My Business",
		titleKey: "nav.intelligence.dashboard.myBusiness.title",
		label: "My Business",
		labelKey: "nav.intelligence.dashboard.myBusiness.label",
		icon: "business",
		buttons: [],
		actions: []
	},
	"/intelligence/dashboard/market-conditions": {
		nav: true,
		title: "Market Conditions",
		titleKey: "nav.intelligence.dashboard.marketConditions.title",
		label: "Market Conditions",
		labelKey: "nav.intelligence.dashboard.marketConditions.label",
		icon: "trending_up",
		buttons: [],
		actions: []
	},
	"/intelligence/dashboard/season-tracker": {
		nav: true,
		title: "Season Tracker",
		titleKey: "nav.intelligence.dashboard.seasonTracker.title",
		label: "Season Tracker",
		labelKey: "nav.intelligence.dashboard.seasonTracker.label",
		icon: "thermostat",
		buttons: [],
		actions: []
	}
};

export const featurePageMapping: { [key: string]: PageMapping } = {
	"/intelligence": {
		nav: false,
		title: "",
		label: "INTELLIGENCE",
		labelKey: "nav.intelligence.module.label",
		icon: "home",
		buttons: [],
		actions: []
	},
	"/intelligence/dashboard": {
		nav: true,
		title: "Dashboard",
		titleKey: "nav.intelligence.dashboard.title",
		label: "Dashboard",
		labelKey: "nav.intelligence.dashboard.label",
		icon: "dashboard",
		buttons: [],
		actions: [],
		children: dashboardSectionMapping
	},
	"/intelligence/research": {
		nav: true,
		title: "Research",
		titleKey: "nav.intelligence.research.title",
		label: "Research",
		labelKey: "nav.intelligence.research.label",
		icon: "summarize",
		buttons: [],
		actions: []
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping,
	...dashboardSectionMapping
};
